import React, { Component } from 'react';
import { Card, CardBody, CardTitle, Alert } from 'reactstrap';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';

import { If } from 'utils';
import { UiKit } from 'components';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import { selectHelpers } from 'utils/uiKitHelpers';
import { fetchRetailers, requestLink } from 'utils/services';

const defaultState = {
  step: 1,
  email: '',
  success: null,
  processing: null,
  retailerList: []
};

export default class Request extends Component {
  state = defaultState;

  handleChange = e => this.setState({ email: e.target.value });

  reset = () => this.setState(Object.assign({}, defaultState));

  getRequestLink = values => {
    this.setState({ processing: true });
    requestLink(
      values,
      () => this.setState({ success: true, processing: false }),
      () => this.setState({ success: false, processing: false })
    );
  };

  fetchRetailerList = ({ email }) => {
    fetchRetailers(
      { email },
      retailers => {
        const validRetailers = Object.keys(retailers).reduce((acc, key) => {
          if (retailers[key].length > 0) {
            acc.push({ name: key, stores: retailers[key] });
          }
          return acc;
        }, []);

        const { options } = selectHelpers.createOptions(validRetailers, {
          getLabel: item => _get(item, 'name', ''),
          getValue: item => _get(item, 'rr_store_id') || _get(item, 'name'),
          getOptions: item => _get(item, 'stores', [])
        });

        const accountsCount = _size(options);
        const firstAccountStoresCount = _size(_get(options, '[0].options', []));
        const hasOnlyOneStore =
          accountsCount === 1 && firstAccountStoresCount === 1;

        if (!_isEmpty(options) && !hasOnlyOneStore) {
          this.setState({
            email,
            step: 2,
            retailerList: options
          });
        } else {
          this.getRequestLink({
            email,
            retailer_id: _get(options, '[0].options[0].value', null)
          });
        }
      },
      () => {
        this.setState({ loading: false });
        // this.setError('msg');
      }
    );
  };

  render() {
    const { success, processing, step } = this.state;
    return (
      <Card className="request-link login-card">
        <CardBody className="p-0">
          <CardTitle className="text-center">Reset your password</CardTitle>
          <p className="text-light description">
            To reset your password, enter the email address you use to sign in.
          </p>
          <UiKit.Grid templateColumns="1fr" gap="16">
            <If test={step === 1}>
              <StepOne
                success={success}
                processing={processing}
                onSubmit={this.fetchRetailerList}
              />
            </If>
            <If test={step === 2}>
              <StepTwo
                success={success}
                email={this.state.email}
                retailers={this.state.retailerList}
                processing={processing}
                onSubmit={this.getRequestLink}
              />
            </If>
            <If test={success !== null}>
              <Alert color={success ? 'success' : 'danger'} className="m-0">
                {success
                  ? `Check your inbox for the instructions to reset your password.`
                  : 'Something went wrong. Please verify the details provided or try again in sometime.'}
              </Alert>
            </If>
          </UiKit.Grid>
          <If test={step === 2}>
            <div className="text-right">
              <span className="reset-link" onClick={this.reset}>
                Reset form
              </span>
            </div>
          </If>
        </CardBody>
      </Card>
    );
  }
}
